<template>
  <div>
    <!-- Button, popup and selected tags inside the relatively positioned container -->
    <div class="tag-container">
      <!-- replaced button with v-btn -->
      <v-btn @click="togglePopup" small class="ml-2" outlined>
        <v-icon left small>mdi-label</v-icon> {{ $t('settingsLivechat.tags.title') }}
      </v-btn>
      <!-- Popup now inside the container -->
      <div class="popup" v-if="popupVisible">
        <!-- modified popup to use a v-list for displaying tags -->
        <v-list class="popup-tags" dense>
          <v-list-item v-for="(tag, index) in filteredTags" :key="index" @click="addTag(tag)">
            <v-list-item-icon>
              <v-icon small>mdi-tag</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ tag.name }}</v-list-item-title>
              <v-list-item-subtitle>{{ tag.description }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-divider></v-divider>
        <input v-model="filterText" class="tag-filter pa-2" :placeholder="$t('common.search')" />
      </div>
      
      <div class="selected-tags">
        <v-chip
          v-for="(tag, index) in selectedTags"
          :key="index"
          class="ma-1"
          label
          small
          close
          @click:close="removeTag(index)"
        >
          {{ tag }}
        </v-chip>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'LivechatChatTags',
  data() {
    return {
      popupVisible: false,
      filterText: ''
    };
  },
  computed: {
    ...mapGetters('livechat', ['organization', 'activeChat']),
    selectedTags() {
      return this.activeChat ? this.activeChat.tags : [];
    },
    filteredTags() {
      return this.tags.filter(tag =>
        tag.name.toLowerCase().includes(this.filterText.toLowerCase())
      );
    },
    tags() {
      return this.organization.tags || [];
    }
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
    document.addEventListener('keydown', this.handleKeydown);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
    document.removeEventListener('keydown', this.handleKeydown);
  },
  methods: {
    ...mapActions('livechat', ['addTagToChat', 'removeTagFromChat']),
    togglePopup() {
      this.popupVisible = !this.popupVisible;
    },
    addTag(tag) {
      if (!this.selectedTags.some(selected => selected === tag.name)) {
        this.addTagToChat({ tag: tag.name, chatUuid: this.activeChat.uuid });
      }
      this.popupVisible = false;
      this.filterText = '';
    },
    handleClickOutside(e) {
      if (!this.$el.contains(e.target) && this.popupVisible) {
        this.popupVisible = false;
        this.filterText = '';
      }
    },
    handleKeydown(e) {
      if (e.key === 'Escape' && this.popupVisible) {
        this.popupVisible = false;
        this.filterText = '';
      }
    },
    removeTag(index) {
      const tag = this.selectedTags[index];
      if (tag) {
        this.removeTagFromChat({ tag, chatUuid: this.activeChat.uuid });
      }
    }
  }
};
</script>

<style scoped>
.tag-container {
  display: flex;
  align-items: center;
  position: relative;
}
.selected-tags {
  display: flex;
  margin-left: 10px;
}

.tag {
  background: #eee;
  border: 1px solid #ccc;
  padding: 5px 8px;
  margin-right: 5px;
  border-radius: 3px;
}
.popup {
  /* modified width to make the popup wider */
  position: absolute;
  bottom: 100%;
  left: 0;
  background: white;
  border: 1px solid #ccc;
  margin-bottom: 5px;
  z-index: 10;
  width: 250px;
}
.popup input {
  width: 100%;
  padding: 5px;
  margin-bottom: 5px;
}
.popup-tags {
  /* added styles for scrollable list of tags */
  max-height: 175px; /* adjust height to show approx. 5 items */
  overflow-y: auto;
}

.tag-filter:focus-within {
  outline: none;
}
</style>
